import React from "react";
import { Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
export class AddInformation extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:""
        }
    }
    render(){
        return(
            <div className="manage-order-container">
                <div className="manage-order-detail">
                    <InputField label="UPLOAD SPEED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="DOWNLOAD SPEED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="REQUEST IP" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                </div>
                     <InputField label="REQUEST IP" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
            </div>
        )
    }
}